module.exports = __webpack_public_path__ + "img/1.760dea4a.png";